import React, { useEffect, useState } from 'react';
import ReactPlayer from 'react-player';
import { 
    Col, Row, Result,
    Typography, Button, 
    Divider,Descriptions,
} from 'antd';
import { 
    doc, onSnapshot, 
    collection, 
    query as queryFirestore, 
    where, addDoc,
} from "firebase/firestore";
import { useHistory } from 'react-router-dom';

import { firestore } from '../../services/firebase';
import { useQuery, useAuth } from "../../hooks";
import { LeftOutlined } from "@ant-design/icons"
import AppLoading from '../../components/AppLoading';
import { formatDate } from '../../utilities';

const VideoEmbed = () => {

    const { Title } = Typography;
    const query = useQuery();
    const id = query.get("id");
    const { userData } = useAuth();
    const {  apellidos, ciudad, correo, empresa, idDoc, nombre, ocupacion, pais, telefono, rol } = userData[0];
    const history = useHistory();

    const [ loading, setLoading ] = useState(true);
    const [ video, setVideo ] = useState([]);
    const [ playVideo, setPlayVideo ] = useState(false);
    const [ visitas, setVisitas ] = useState(null);
    const [ userIp, setUserIp ] = useState("");

  
    // Agregar registro al contador
    const countUserPlay = async () => {
        setPlayVideo(true);
        if( !playVideo ){
            let data = {
                idUsuario: idDoc,
                idVideo: id,
                fecha_visita: new Date(),
                ipUsuario: userIp,
                usuario_info: {
                    idUsuario: idDoc,
                    apellidos: apellidos,
                    ciudad: ciudad,
                    correo: correo,
                    empresa: empresa,
                    nombre: nombre,
                    ocupacion: ocupacion,
                    pais: pais,
                    telefono: telefono,
                }

            }
            await addDoc( collection(firestore, "contador", ), data );
        }
    }

    useEffect( () => {

        fetch('https://api.ipify.org/?format=json')
        .then(response => response.json())
        .then(data => setUserIp(data.ip));
    
        onSnapshot(doc(firestore, "videos", id), (doc) => {
            setVideo(doc.data());
            setLoading(false);
        });

        const q = queryFirestore(collection(firestore, "contador"), where("idVideo", "==", id));
        onSnapshot(q, (querySnapshot) => {
            const videosInfo = [];
            let count = 0;
            querySnapshot.forEach((doc) => {
                if( doc.data().idUsuario  ) {
                    videosInfo.push(doc.data());
                    count++;
                }
            });
            setVisitas(count);
        });

    }, [ id ] );

    if( loading ) { return <AppLoading  />  }
    
    let fechaHoy = new Date();
    fechaHoy = fechaHoy.getTime();
    let fechaInicio = video.horario.toDate().getTime();

    return (
        <>
            <Row 
                gutter={{ xs: 10, sm: 10, md: 10, lg: 10}}
                style={{ marginBottom: 40 }}
            >
                <Col
                    xs={{  span: 24, offset: 0 }} 
                    sm={{  span: 13, offset: 0 }} 
                    md={{  span: 12, offset: 0 }} 
                    lg={{  span: 12, offset: 0 }}  
                    xxl={{ span: 12, offset: 0 }}
                >
                    <Title level={4}>{ video?.nombre }</Title>
                </Col>
                <Col
                    xs={{  span: 24, offset: 0 }} 
                    sm={{  span: 7, offset: 4 }} 
                    md={{  span: 5, offset: 7 }} 
                    lg={{  span: 4, offset: 8 }}  
                    xxl={{ span: 3, offset: 9  }}
                >

                    <Button 
                        type='primary'
                        block
                        icon={ <LeftOutlined /> }
                        onClick={ () => history.goBack() }
                        size="large"
                        >Volver
                    </Button>
                </Col>
            </Row>
            
            <Row gutter={{ xs: 10, sm: 10, md: 10, lg: 0}}>
                <Col
                    xs={{  span: 24, offset: 0 }} 
                    sm={{  span: 24, offset: 0 }} 
                    md={{  span: 24, offset: 0 }} 
                    lg={{  span: 16, offset: 0 }}  
                    xxl={{ span: 16, offset: 0 }}
                >
                    {
                        fechaHoy  >= fechaInicio ? 
                        ( 
                            <ReactPlayer 
                                url={ video?.url }
                                width='100%'
                                height='500px'
                                controls={true}
                                onPlay={ countUserPlay }
                            /> 
                        ) : (
                            <Result
                                status="info"
                                title={ 'Estreno: ' + formatDate( video.horario.toDate() ) }
                            />
                        )
                    }
                    
                </Col>
           
                <Col
                    xs={{  span: 24, offset: 0 }} 
                    sm={{  span: 24, offset: 0 }} 
                    md={{  span: 24, offset: 0 }} 
                    lg={{  span: 7, offset: 1 }}  
                    xxl={{ span: 7, offset: 1 }}
                >
                    <Descriptions 
                        layout="vertical"
                    >
                        { rol === 'admin' && (
                            <>
                                <Descriptions.Item label="Autor">{ video?.autor }</Descriptions.Item>
                                <Descriptions.Item label="Visitas">{ visitas }</Descriptions.Item>
                            </>
                        ) }
                        <Descriptions.Item label="Horario">{ formatDate(video?.horario.toDate()) }</Descriptions.Item>
                    </Descriptions>

                    <Divider dashed />
                    { video?.descripcion }                    
                </Col>
            </Row>

            
        </>
    )
}

export default VideoEmbed
